var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6973 10.5788L13.9171 2.26429C12.8416 1.24654 11.1578 1.24654 10.0831 2.26429L1.3238 10.56C0.7928 11.0235 0.61055 11.7503 0.8588 12.4125C1.10705 13.0733 1.72205 13.5 2.4263 13.5H3.00005V21.75C3.00005 22.164 3.33605 22.5 3.75005 22.5H20.25C20.6641 22.5 21 22.164 21 21.75V13.5H21.5731C22.2773 13.5 22.8931 13.0725 23.1406 12.411C23.3888 11.7495 23.2058 11.022 22.6973 10.5788ZM9.75005 21V17.25C9.75005 16.0095 10.7596 15 12.0001 15C13.2406 15 14.2501 16.0095 14.2501 17.25V21H9.75005ZM21.5731 12H20.25C19.8361 12 19.5 12.336 19.5 12.75V21H15.7501V17.25C15.7501 15.1823 14.0678 13.5 12.0001 13.5C9.9323 13.5 8.25005 15.1823 8.25005 17.25V21H4.50005V12.75C4.50005 12.336 4.16405 12 3.75005 12H2.4263C2.27705 12 2.16905 11.8133 2.33255 11.6693L11.1143 3.35329C11.6108 2.88304 12.3893 2.88304 12.8858 3.35329L21.6885 11.6888C21.8116 11.7953 21.7358 12 21.5731 12Z",
    fill: "#3469E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueHomeIcon);
export default __webpack_public_path__ + "static/media/BlueHomeIcon.927c80a434f34b345505070bc09dbf97.svg";
export { ForwardRef as ReactComponent };